import { CustomStringParam, SchemaFilterType } from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'Customer',
    sortable: false,
  },
  {
    name: 'totalWarnings',
    label: 'All Warnings',
    sortable: false,
  },
  {
    name: 'percentOfTotal',
    label: '% of total',
    sortable: false,
  },
  {
    name: 'customersBlockListOngoingMonitoring',
    label: 'Customers block list ongoing monitoring',
    sortable: false,
  },
  {
    name: 'transactionsBlockListsMonitoring',
    label: 'Transactions block lists monitoring',
    sortable: false,
  },
  {
    name: 'transactionsRiskScoringMonitoring',
    label: 'Transactions risk scoring',
    sortable: false,
  },
  {
    name: 'transactionsMonitoringRules',
    label: 'Transactions monitoring rules',
    sortable: false,
  },
  {
    name: 'paymentsOrdersBlocklistsMonitoring',
    label: 'Payment orders block lists monitoring',
    sortable: false,
  },
  {
    name: 'paymentsOrdersMonitoringRules',
    label: 'Payment orders monitoring rules',
    sortable: false,
    filterModalPlacement: 'right',
  },
  {
    name: 'transactionsAgreements',
    label: 'Agreements',
    sortable: false,
  },
];

export const columnsLabels = {};

export const schema = {
  createdAt: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['createdAtFrom', 'createdAtTo'],
  },
  createdAtFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  createdAtTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  organizationId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  organizationType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  transactionTypeId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  transactionPaymentType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  paymentOrderType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  actions: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [];
